import { useEffect } from 'react';


// https://github.com/jeduan/cordova-plugin-facebook4

export default function FacebookAuthCordova({ state, updateState }) {

  useEffect(() => {
    if (state.initialized)
      return () => {};

    function updateLoginStatus(response) {
      const { status }       = response;
      const isSignedIn       = status === 'connected';
      const { authResponse } = response;
      const accessToken      = authResponse?.accessToken;
      updateState({ isSignedIn, accessToken });
    }

    const { facebookConnectPlugin } = window;
    facebookConnectPlugin.getLoginStatus(updateLoginStatus);

    window.FB = {
      // Getting this error when trying to request `manage_pages` in the
      // initial login call: "You can only ask for read permissions initially"
      // https://github.com/fourseven/FacebookConnect/blob/master/src/ios/FacebookConnectPlugin.m#L237
      //
      // "Publish Permissions - You must request these separately from read
      // permissions. You should only request publish permissions after
      // someone takes an action that requires it."
      // https://developers.facebook.com/docs/facebook-login/ios/permissions
      //
      // As a workaround, the Cordova implementation first calls login with an
      // empty permissions array to get the default read-only permisions
      // (email, public_profile), and then calls login with the requested
      // manage_pages permission.
      login(cb, options = {}) {
        facebookConnectPlugin.login(
          [],
          () => {
            const permissions = [ options.scope ].filter(Boolean);
            facebookConnectPlugin.login(permissions, updateLoginStatus, logError);
          },
          logError
        );
      },
      logout(cb) {
        facebookConnectPlugin.logout(
          res => {
            updateState({
              isSignedIn:  false,
              accessToken: null
            });
            cb(res);
          },
          logError
        );
      },
      // eslint-disable-next-line max-params
      api(endpoint, method, opts, cb) {
        const permissions = [];
        facebookConnectPlugin.api(endpoint, permissions, cb, logError);
      }
    };

    updateState({ initialized: true });

    return () => {};

  }, [ state.initialized, updateState ]);

  return null;
}

// Facebook plugin requires an error callback to be passed in to the various
// methods. We're not doing anything with those errors, so we're passing a no-op
// function to satify that requirement.
function logError() {}
